import { Extension } from 'tiptap';
import MoreCommandsMenu from './MoreCommandsMenu.vue';

/* eslint-disable */
export default class Fullscreen extends Extension {
  get name() {
    return 'morecommands';
  }

  menuBtnView(editorContext) {
    return {
      component: MoreCommandsMenu,
      componentProps: {
        editorContext,
      },
    };
  }
}
